<template>
  <div>
    <div>Most frequently asked questions</div>
    <div class="bg-float-default-low mt-16 h-[300px]"></div>
  </div>
</template>

<script setup lang="ts"></script>
